module.exports = __webpack_public_path__ + "static/media/eye.421e7376.svg";